{
    "2QELknUpaqZXZtdt0typD": {
        "tag": "spawngood",
        "key": "2QELknUpaqZXZtdt0typD",
        "position": {
            "x": 1,
            "y": 1,
            "z": 1
        }
    }
}
